import { Button, MultiSelect } from "@etframework/ui.components";
import PropTypes from "prop-types";
import {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";

export const SelectUsers = forwardRef(
  ({ click, accessGridRef, usersDataSource, onChange, id }, ref) => {
    const { t, i18n } = useTranslation(["AccessModal"]);
    const multiSelectRef = useRef(null);
    const [values, setValues] = useState();
    const [usersInGrid, setUsersInGrid] = useState(
      accessGridRef?.current?.getData()
    );

    const excludeIds = usersInGrid?.map((item) => item.UserId ?? item.Id);
    const filteredUsers = usersDataSource?.filter(
      (user) => !excludeIds?.includes(user.Id)
    );

    const handleOnChange = (e) => {
      onChange?.(e.value);
      setValues(e.value);
    };

    const onClick = () => {
      const selected = multiSelectRef.current.getValue();

      if (typeof click === "function") {
        click(selected);
      }
    };

    const clear = useCallback(() => {
      multiSelectRef.current.clear();
    }, []);

    const setShowError = useCallback((show) => {
      multiSelectRef.current.setShowError(show);
    }, []);

    useImperativeHandle(ref, () => ({
      clear,
      setShowError,
      getData: () => multiSelectRef.current.getValue(),
      setUsersInGrid,
    }));

    return (
      <div id={id} className="space-y-4 p-3">
        <MultiSelect
          id={id + '_dropdown'}
          ref={multiSelectRef}
          value={values}
          dataSource={filteredUsers ?? []}
          fields={{ value: "Id", text: "FullName" }}
          htmlFor={id + '_dropdown'}
          label={t("SearchUsers")}
          errorMessage={t("CompleteField")}
          change={handleOnChange}
          locale={i18n?.language}
          allowObjectBinding
          sortOrder="Ascending"
        />
        <div className="d-flex justify-content-between">
          <div></div>
          <div>
            <Button
              id={id + '_add-to-list-button'}
              text={t("AddToList")}
              onClick={onClick}
              className="select-users-multiselect-btn"
            />
          </div>
        </div>
      </div>
    );
  }
);

SelectUsers.displayName = "SelectUsers";

SelectUsers.propTypes = {
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  click: PropTypes.func,
};
